import Summaries from "./Summaries";

export default Summaries;
